/**
 * The configuration file for the eslintrc.json file to support lint --fix command.
 */
export const adds = [
    {
        toBeAdded: '"ignorePatterns": ["!*.spec.ts"]',
        toBeAddedAfter: '"extends": "./node_modules/@microsoft/windows-admin-center-sdk/tools/code-formatter/.eslintrc.base.json"',
        indent: 2,
        keyword: '"ignorePatterns": ["!*.spec.ts"]'
    }
];
